import * as React from 'react';
import * as styles from './HttpError.css';
import { IAIcon } from '../icon/Icon';
import { IHttpStatus } from '../../interfaces/IHttpStatus';
import { IAButton } from '../button/Button';
import { LocalizationService } from '../../services/LocalizationService';

export interface IProps {
  httpStatus: IHttpStatus;
}

export interface IState {
  showMore: boolean;
}

export class IAHttpError extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      showMore: false
    };
    
  }

  public render(): JSX.Element {
    let errorType;
    switch (this.props.httpStatus.statusCode) {
      case 401: // Authentication fails
        errorType = new LocalizationService().strings.HttpError_401
        break;
      case 403: // Forbidden (Permissions)
        errorType = new LocalizationService().strings.HttpError_403
        break;
      case 404: // Not found
        errorType = new LocalizationService().strings.HttpError_404
        break;
      case 503: // Busy
        errorType = new LocalizationService().strings.HttpError_503
        break;
      default: // Unknown exception
        errorType = new LocalizationService().strings.HttpError_500
        break;
    }
    return (
      <div
        className={styles.IA_httpError}
      >
        <div
          className={styles.icon}
        >
          <IAIcon
            title="Emoji Suprised"
            size={22}
            color={"#333333"}
            style={{
              float: "left",
              marginRight: 10
            }}
          />
          {errorType}
        </div>
        {this.state.showMore ?
          <div
            className={styles.message}
          >
            {this.props.httpStatus.message}
          </div>
          :
          <IAButton
            label={new LocalizationService().strings.HttpError_SeeMoreButton}
            buttonColor="#d7a613"
            showSpinner={false}
            onClick={() => {
              this.setState({ showMore: true });
            }}
            style={{
              clear: "both",
              marginTop: 20,
              float: "left"
            }}
          />
        }
      </div>
    );
  }
}